import {
  Edit,
  CardActions,
  ListButton,
  RefreshButton,
  DeleteButton,
  translate
} from "react-admin";
import moment from 'moment'
import React from "react";

import FacilityBookingForm from "./FacilityBookingForm";

const FacilityBookingTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("facilitybooking.facilitybooking")}`} {record ? `${moment(record.booking_date).format('DD MMM YYYY')}` : ""}
    </span>
  );
};

const Title = translate(FacilityBookingTitle);

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    <DeleteButton basePath={basePath} record={data} resource={resource} />
    <RefreshButton />
  </CardActions>
);

export const FacilityBookingEdit = props => (
  <Edit actions={<Actions />} title={<Title />} {...props}>
    <FacilityBookingForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/facilitybooking/FacilityBookingEdit.js